import React, { useEffect } from 'react';
import { useProfileStore } from '../../state/profileStore';
import { useParams, useNavigate } from 'react-router-dom';
import UserProfile from './userprofile';

function NewUserProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const user = useProfileStore((s) => s.profile);

  useEffect(() => {
    // Redirect to plain /profile (own-profile is identified by session, no
    // slug needed). Brett caught the smoking gun 2026-05-26: pre-fix this
    // built a slug from u_first_name + u_last_name and navigated to
    // /profile/<slug>. After the Unicode-safe sanitizer fix that allowed
    // Thai/Japanese/etc. in names, that slug became e.g.
    // ศิริพร_วงษ์สุวรรณ which the browser percent-encodes to a 200-byte URL.
    // Chrome's URL bar hitches rendering very-long mixed-encoding URLs (a
    // known Chromium quirk), and during that hitch, click events queue
    // behind the main thread, producing the "click does nothing for 3
    // seconds" symptom. Going to plain /profile avoids the issue entirely
    // — the route still shows the user's own profile via session lookup.
    if (user) {
      navigate('/profile', { replace: true });
    }
  }, [user, navigate]);

  // If no user data or ID doesn't match, show loading
  if (!user || user.u_id !== parseInt(id)) {
    return <div className="container mx-auto w-4/5 p-6">Loading profile...</div>;
  }

  // Render the regular UserProfile component
  return <UserProfile />;
}

export default NewUserProfile;